import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { confirmTextTask } from '@/features/orders/ordering/services/orderWorkflowService.js';
import { MODAL_TYPES, ROLE_TYPES } from '@/constants/constants.js';
import TextGroup from '@/components/TextGroup.js';

export const useAiTextsForm = (
  client_id,
  role,
  setDisabled_AiText,
  navigate,
  setIsSubmitting,
  useAiText
) => {
  return useFormik({
    initialValues: {
      speech_text: '',
      farewell_text: '',
      custom_speech_text: '',
      custom_farewell_text: '',
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const speech = useAiText
          ? values.speech_text
          : values.custom_speech_text;
        const farewell = useAiText
          ? values.farewell_text
          : values.custom_farewell_text;
        await confirmTextTask(client_id, speech, farewell, role);
        if (role === ROLE_TYPES.客服) {
          setDisabled_AiText(true);
          navigate(`/review/${client_id}`);
        }
      } catch (error) {
        console.error('文案确认失败:', error);
      } finally {
        setIsSubmitting(false);
      }
    },
  });
};

export const AiTextsForm = ({
  formik_AiTexts,
  disabled_AiText,
  setConfirmText,
  setModalType,
  setModalVisible,
  speechLimit,
  farewellLimit,
  role,
  isConfirmButtonDisabled,
  useAiText,
  setUseAiText,
  isSpeechLengthOverflow,
  setIsSpeechLengthOverflow,
  isFarewellLengthOverflow,
  setIsFarewellLengthOverflow,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [originalValue, setOriginalValue] = useState(formik_AiTexts.values);
  const SpeechLength = (
    useAiText
      ? formik_AiTexts.values.speech_text || ''
      : formik_AiTexts.values.custom_speech_text || ''
  ).replace(/[^\p{L}\p{N}]/gu, '').length;
  const FarewellLength = (
    useAiText
      ? formik_AiTexts.values.farewell_text || ''
      : formik_AiTexts.values.custom_farewell_text || ''
  ).replace(/[^\p{L}\p{N}]/gu, '').length;

  useEffect(() => {
    if (
      JSON.stringify(originalValue) !== JSON.stringify(formik_AiTexts.values)
    ) {
      if (SpeechLength > speechLimit) {
        setIsSpeechLengthOverflow(true);
      } else {
        setIsSpeechLengthOverflow(false);
      }
      if (FarewellLength > farewellLimit) {
        setIsFarewellLengthOverflow(true);
      } else {
        setIsFarewellLengthOverflow(false);
      }
    }
  }, [
    useAiText,
    FarewellLength,
    SpeechLength,
    farewellLimit,
    formik_AiTexts.values,
    originalValue,
    speechLimit,
    setIsSpeechLengthOverflow,
    setIsFarewellLengthOverflow,
  ]);

  const btnsSelect = () => {
    return (
      <ButtonGroup>
        <button
          type="button"
          className={useAiText ? 'btn btn-primary' : 'btn btn-outline-primary'}
          onClick={() => setUseAiText(true)}
          disabled={disabled_AiText}
        >
          使用AI文案
        </button>
        <button
          type="button"
          className={!useAiText ? 'btn btn-primary' : 'btn btn-outline-primary'}
          onClick={() => setUseAiText(false)}
          disabled={disabled_AiText}
        >
          使用自拟文案
        </button>
      </ButtonGroup>
    );
  };

  return (
    <form className="row g-3" onSubmit={formik_AiTexts.handleSubmit}>
      <>
        <TextGroup
          formik={formik_AiTexts}
          disabled={disabled_AiText}
          groupLabel="视频文案"
          inputLabels={[
            '致辞',
            farewellLimit === undefined || farewellLimit > 0
              ? '告别'
              : undefined,
          ]}
          name={
            useAiText
              ? ['speech_text', 'farewell_text']
              : ['custom_speech_text', 'custom_farewell_text']
          }
          style={{ minHeight: '10rem' }}
          onChange={formik_AiTexts.handleChange}
          maxLength={role === ROLE_TYPES.客服 && [speechLimit, farewellLimit]}
          overFlow={[isSpeechLengthOverflow, isFarewellLengthOverflow]}
          length={[SpeechLength, FarewellLength]}
          additionalContent={btnsSelect()}
        />
        {!disabled_AiText && (
          <>
            {role === ROLE_TYPES.客服 && (
              <div style={{ color: 'red', marginBottom: '0.5rem' }}>
                {isConfirmButtonDisabled
                  ? '有必填项未填写，无法确认文案。请先补全资料。'
                  : isSpeechLengthOverflow || isFarewellLengthOverflow
                  ? '文案长度超出限制，请重新输入。'
                  : '请与用户确认文案。（不必立即点击 "客户已确认" 按钮，与客户确认文案完毕后可再次进入该页面点击 "客户已确认"按钮'}
              </div>
            )}
          </>
        )}
        {role === ROLE_TYPES.管理员 && (
          <div className="confirm-btn-cotainer">
            <Button
              onClick={() => {
                setConfirmText('确认文案正确');
                setModalType(MODAL_TYPES.管理员修改文案);
                setModalVisible(true);
              }}
            >
              修改文案(仅修改文案，不确认文案)
            </Button>
          </div>
        )}
      </>
    </form>
  );
};
